import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { API_URL } from "@/common/utils/env";

export default function useLinearInitiateConnectionUrl(): string {
  const { org, app } = useEnvironment();

  if (!org || !app) {
    return "";
  }

  const redirectUri = window.location.href.replace(window.location.origin, "");

  const searchParams = {
    redirectUri,
    appId: app.id,
  };

  return `${API_URL}/orgs/${org.id}/linear/connect?${new URLSearchParams(
    searchParams,
  ).toString()}`;
}
